<template>
    <div>
        <div class="banner">
            <van-row>
                <van-col span="4" @click="back">
                    <img class="back-icon"
                         :src="require(`@/assets/theme/${theme}/status/01dailyActive/01back.svg`)">
                </van-col>
                <van-col span="16">
                    <div class="banner-title" v-if="info">{{ getName(info) }}</div>
                </van-col>
            </van-row>
        </div>
        <div class="loading" v-if="info.showMedal == 0 && info.stage == 2 && info.rank < 4 && info.rank > 0">
            <div class="prop-box">
                <img class="medal-close" @click="info.showMedal = 1"
                     :src="require(`@/assets/theme/light/sport/01challengeList/12close.svg`)">
                <img class="medal-prop" :src="info.medal1[0].url" v-if="info.rank == 1">
                <img class="medal-prop" :src="info.medal2[0].url" v-if="info.rank == 2">
                <img class="medal-prop" :src="info.medal3[0].url" v-if="info.rank == 3">
                <div class="medal-text1">{{ $t('challengeDesc.medalPop') }}</div>
                <div class="medal-text2">{{ $t('challengeDesc.no0') }} <span class="c-light">{{
                        info.rank
                    }} </span>{{ $t('challengeDesc.no1') }}
                </div>
                <div class="accept" @click="setViewed">{{ $t('challengeDesc.accept') }}</div>
            </div>
        </div>
        <div class="content" v-if="!showMap">
            <div class="finishBox" v-if="info.stage == 2">
                <div class="new-item-badge">{{ $t('challengeDesc.over') }}</div>
            </div>
            <div class="c-item">
                <img class="c-icon" :src="require(`@/assets/theme/light/sport/01challengeList/08info.svg`)">
                <div class="c-text">{{ $t('challengeDesc.join') }}：<span
                    class="c-light">{{ info.participantNum }}</span></div>
            </div>
            <div class="c-item" v-if="info.stage != 2">
                <img class="c-icon" :src="require(`@/assets/theme/light/sport/01challengeList/05time.svg`)">
                <div class="c-text">{{ $t('challengeDesc.end0') }}：<span
                    class="c-light">{{ getDistanceDays(new Date(), info.endDate) }} </span>{{
                        $t('challengeDesc.end1')
                    }}
                </div>
            </div>
            <div class="c-item" v-if="info.userChallengeId&&info.attribute == 0">
                <img class="c-icon" :src="require(`@/assets/theme/light/sport/01challengeList/07info.svg`)">
                <div class="c-text">{{ $t('challengeDesc.rDistance0') }}：<span
                    class="c-light">{{
                        ((info.target - info.totalData) / 100000).toFixed(2)
                    }} </span> {{ $t('challengeDesc.distanceUnit') }}
                </div>
            </div>
            <div class="c-item" v-if="info.userChallengeId&&info.attribute == 1">
                <img class="c-icon" :src="require(`@/assets/theme/${theme}/sport/01challengeList/07info.svg`)">
                <div class="c-text">{{ $t('challengeDesc.tDistance') }}：<span
                    class="c-light">{{
                        (info.totalData / 100000).toFixed(2)
                    }} </span>{{ $t('challengeDesc.distanceUnit') }}
                </div>
            </div>
            <div class="c-item" v-if="info.userChallengeId&&info.attribute == 3">
                <img class="c-icon" :src="require(`@/assets/theme/light/sport/01challengeList/11race.svg`)">
                <div class="c-text">{{ $t('challengeDesc.race') }}：<span
                    class="c-light">{{ info.totalData ? formatSeconds(info.totalData) : '--' }}</span>
                </div>
            </div>
            <div class="c-item" v-if="info.userChallengeId&&info.attribute == 2">
                <img class="c-icon" :src="require(`@/assets/theme/light/sport/01challengeList/10cal.svg`)">
                <div class="c-text">{{ $t('challengeDesc.cal') }}：<span
                    class="c-light">{{
                        info.totalData ? parseInt(info.totalData / 1000) : '--'
                    }} </span>{{ $t('challengeDesc.calUnit') }}
                </div>
            </div>
            <div class="c-item" v-if="info.userChallengeId&&info.attribute == 4">
                <img class="c-icon" :src="require(`@/assets/theme/${theme}/sport/01challengeList/07info.svg`)">
                <div class="c-text">{{ $t('challengeDesc.step') }}：<span
                    class="c-light">{{ info.totalData }} </span>{{ $t('challengeDesc.stepUnit') }}
                </div>
            </div>
            <div class="c-item" v-if="info.userChallengeId">
                <img class="c-icon" :src="require(`@/assets/theme/${theme}/sport/01challengeList/06rank.svg`)">
                <div class="c-text">{{ $t('challengeDesc.no0') }}<span class="c-light"> {{
                        info.rank ? info.rank : '--'
                    }} </span>{{ $t('challengeDesc.no1') }}
                </div>
                <div class="see-map" @click="showMap=true" v-if="info.attribute == 0">{{ $t('challengeDesc.down') }}<img
                    class="down-icon"
                    :src="require(`@/assets/theme/light/sport/03challengeDesc/01down.png`)">
                </div>
            </div>
        </div>
        <div class="map-box" v-if="showMap">
            <div class="map-content">
                <div class="c-item">
                    <img class="c-icon" :src="require(`@/assets/theme/${theme}/sport/01challengeList/08info.png`)">
                    <div class="c-text">{{ $t('challengeDesc.join') }}：<span class="c-light">{{
                            info.participantNum
                        }}</span></div>
                </div>
                <div class="c-item">
                    <img class="c-icon" :src="require(`@/assets/theme/${theme}/sport/01challengeList/05time.svg`)">
                    <div class="c-text">{{ $t('challengeDesc.end0') }}：<span
                        class="c-light">{{
                            getDistanceDays(new Date(), info.endDate)
                        }} </span>{{ $t('challengeDesc.end1') }}
                    </div>
                </div>
                <div class="c-item" v-if="info.userChallengeId&&info.attribute == 0">
                    <img class="c-icon" :src="require(`@/assets/theme/light/sport/01challengeList/07info.svg`)">
                    <div class="c-text">{{ $t('challengeDesc.rDistance0') }}：<span
                        class="c-light">{{
                            ((info.target - info.totalData) / 100000).toFixed(2)
                        }} </span>{{ $t('challengeDesc.distanceUnit') }}
                    </div>
                </div>
                <div class="c-item" v-if="info.userChallengeId&&info.attribute == 1">
                    <img class="c-icon" :src="require(`@/assets/theme/light/sport/01challengeList/07info.svg`)">
                    <div class="c-text">{{ $t('challengeDesc.tDistance0') }}：<span
                        class="c-light">{{
                            (info.totalData / 100000).toFixed(2)
                        }} </span>{{ $t('challengeDesc.distanceUnit') }}
                    </div>
                </div>
                <div class="c-item" v-if="info.userChallengeId&&info.attribute == 3">
                    <img class="c-icon" :src="require(`@/assets/theme/light/sport/01challengeList/07info.svg`)">
                    <div class="c-text">{{ $t('challengeDesc.race') }}：<span
                        class="c-light">{{ info.totalData ? formatSeconds(info.totalData) : '--' }} </span>
                    </div>
                </div>
                <div class="c-item" v-if="info.userChallengeId&&info.attribute == 2">
                    <img class="c-icon" :src="require(`@/assets/theme/light/sport/01challengeList/10cal.svg`)">
                    <div class="c-text">{{ $t('challengeDesc.cal') }}：<span
                        class="c-light">{{
                            info.totalData ? parseInt(info.totalData / 1000) : '--'
                        }} </span>{{ $t('challengeDesc.calUnit') }}
                    </div>
                </div>
                <div class="c-item" v-if="info.userChallengeId">
                    <img class="c-icon" :src="require(`@/assets/theme/light/sport/01challengeList/06rank.svg`)">
                    <div class="c-text">{{ $t('challengeDesc.no0') }}<span
                        class="c-light">{{ info.rank ? info.rank : '--' }} </span>{{ $t('challengeDesc.no1') }}
                    </div>
                </div>
            </div>
            <div class="hide-map" @click="showMap=false">{{ $t('challengeDesc.up') }}<img class="down-icon"
                                                                                          :src="require(`@/assets/theme/light/sport/03challengeDesc/02up.png`)">
            </div>
            <baidu-map id="map" class="map" :center="center" :zoom="zoom" @ready="initMap"
                       :scroll-wheel-zoom="true">
                <!--                <img v-if="FullScreen" class="map-btn-reduce" src="@/assets/active/full.png"-->
                <!--                     @click="reduce()">-->
            </baidu-map>
        </div>
        <van-tabs v-model="activeType"
                  @change="changeType"
                  title-active-color="var(--text-color-1)"
                  title-inactive-color="var(--text-color-3)"
                  line-height="2"
                  color="var(--text-color-1)"
        >
            <van-tab :title="$t('challengeDesc.tab0')"></van-tab>
            <van-tab :title="$t('challengeDesc.tab1')"></van-tab>
        </van-tabs>
        <div v-if="activeType == 0">
            <div class="info-box">
                <div class="info-item">
                    <div class="info-key">{{ $t('challengeDesc.range') }}</div>
                    <div class="info-value">
                        {{ info.startDate.slice(5, 10).replace(/-/g, '/') }}-{{ info.endDate.slice(5, 10).replace(/-/g, '/') }}
                    </div>
                </div>
                <div class="info-item">
                    <div class="info-key">{{ $t('challengeDesc.type') }}</div>
                    <div class="info-value">{{ $t('challengeDesc.typeValue' )}}</div>
                </div>
                <div class="info-item">
                    <div class="info-key">{{ $t('challengeDesc.attribute') }}</div>
                    <div class="info-value">{{ this.$t('challengeDesc.attributeArr['+info.attribute+']') }}</div>
                </div>
                <div class="info-item">
                    <div class="info-key">{{ $t('challengeDesc.sport') }}</div>
                    <div class="info-value">{{ dealSportType() }}</div>
                </div>
            </div>
            <div class="desc-box">
                <div class="desc-title">{{ $t('challengeDesc.descTitle') }}</div>
                <div class="desc-info desc-last" v-if="info.attribute == 0">
                    {{ $t('challengeType.attribute0.desc0') }} {{ (info.target / 100000).toFixed(2)}} {{$t('challengeType.attribute0.desc1')}}
                </div>
                <div class="desc-info desc-last" v-if="info.attribute != 0">
                    {{ $t('challengeType.attribute'+info.attribute+'.desc') }}
                </div>
            </div>
            <div class="medal-box" v-if="info.stage != 2">
                <div class="d-left">{{$t('challengeDesc.top3')}}：</div>
                <div class="d-right">
                    <div class="medal-list">
                        <img class="medal" :src="info.medal1[0].url">
                        <img class="medal" :src="info.medal2[0].url">
                        <img class="medal" :src="info.medal3[0].url">
                    </div>
                </div>
            </div>
            <div class="medal-box" v-if="info.stage == 2 && info.rank < 4 && info.rank > 0">
                <div class="d-left top3-left">{{ $t('challengeDesc.medalFinish') }} <span class="rank-span">{{ $t('challengeDesc.no0') }}<span
                    class="c-light">{{ info.rank }}</span>{{ $t('challengeDesc.no1') }} </span>
                </div>
                <div class="d-right top3-right">
                    <div class="medal-list">
                        <img class="medal" :src="info.medal1[0].url" v-if="info.rank == 1">
                        <img class="medal" :src="info.medal2[0].url" v-if="info.rank == 2">
                        <img class="medal" :src="info.medal3[0].url" v-if="info.rank == 3">
                    </div>
                </div>
            </div>
            <div class="no-medal" v-if="info.stage == 2 && (info.rank > 4 || !info.rank)">{{ $t('challengeDesc.noMedal') }}</div>
            <div :class="screenHeight > 740 ? 'join-box' : 'join-box-1'" v-if="!info.userChallengeId"
                 @click="addChallenge">{{ $t('challengeDesc.joining') }}
            </div>
        </div>
        <div v-if="activeType == 1">
            <div class="rank-box" v-if="info.attribute == 0">
                <div class="rank-title">
                    <van-row>
                        <van-col span="4">{{ $t('challengeDesc.tableTitle0') }}</van-col>
                        <van-col span="9">{{ $t('challengeDesc.tableTitle1')}}</van-col>
                        <van-col span="6">{{ $t('challengeDesc.tableTitle2')}}</van-col>
                        <van-col span="3">{{ $t('challengeDesc.tableTitle3')}}</van-col>
                    </van-row>
                </div>
                <div class="rank-list">
                    <van-row v-for="item in info.getTopTen" :key="item.userId">
                        <van-col span="4">
                            <div class="rank1" v-if="item.rank == 1">1</div>
                            <div class="rank2" v-if="item.rank == 2">2</div>
                            <div class="rank3" v-if="item.rank == 3">3</div>
                            <div v-if="item.rank > 3">{{ item.rank }}</div>
                        </van-col>
                        <van-col span="9">
                            <div class="user-name" :class="item.userId == userId ? 'c-light' : ''">
                                <img class="user-icon" v-if="item.userAvatar" :src="item.userAvatar">
                                {{ item.userName }}
                            </div>
                        </van-col>
                        <van-col span="6">{{ ((info.target - item.totalData) / 100000).toFixed(2) }}</van-col>
                        <van-col span="3">{{ formatSeconds2(item.totalTime) }}</van-col>
                    </van-row>
                </div>
            </div>
            <div class="rank-box" v-if="info.attribute != 0">
                <div class="rank-title">
                    <van-row>
                        <van-col span="4">{{ $t('challengeDesc.tableTitle0')}}</van-col>
                        <van-col span="14">{{ $t('challengeDesc.tableTitle1')}}</van-col>
                        <van-col span="6" v-if="info.attribute == 1">{{ $t('challengeDesc.tableTitle4')}}</van-col>
                        <van-col span="6" v-if="info.attribute == 2">{{ $t('challengeDesc.tableTitle5')}}</van-col>
                        <van-col span="6" v-if="info.attribute == 3">{{ $t('challengeDesc.tableTitle6')}}</van-col>
                        <van-col span="6" v-if="info.attribute == 4">{{ $t('challengeDesc.tableTitle7')}}</van-col>
                    </van-row>
                </div>
                <div class="rank-list">
                    <van-row v-for="item in info.getTopTen" :key="item.userId">
                        <van-col span="4">
                            <div class="rank1" v-if="item.rank == 1">1</div>
                            <div class="rank2" v-if="item.rank == 2">2</div>
                            <div class="rank3" v-if="item.rank == 3">3</div>
                            <div v-if="item.rank > 3">{{ item.rank }}</div>
                        </van-col>
                        <van-col span="14">
                            <div class="user-name" :class="item.userId == userId ? 'c-light' : ''">
                                <img class="user-icon" v-if="item.userAvatar" :src="item.userAvatar">
                                {{ item.userName }}
                            </div>
                        </van-col>
                        <van-col span="6" v-if="info.attribute == 1">{{ (item.totalData / 100000).toFixed(2) }}
                        </van-col>
                        <van-col span="6" v-if="info.attribute == 2">{{ parseInt(item.totalData / 1000) }}</van-col>
                        <van-col span="6" v-if="info.attribute == 3">{{ formatSeconds(item.totalData) }}</van-col>
                        <van-col span="6" v-if="info.attribute == 4">{{ item.totalData }}</van-col>
                    </van-row>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {getQueryVariable, getSkin, CircleImgOverlay} from '@/utils/comment'
import {getDistanceDays, formatSeconds, formatSeconds2} from '@/utils/dateUtils'
import {Toast} from 'vant'
import BaiduMap from 'vue-baidu-map/components/map/Map.vue'
import mapStyle from '@/assets/theme/light/sport/03challengeDesc/custom_map_config.json'
import {WebJSBridge} from "../../utils/JSBridge1";

export default {
    name: 'challengeDesc',
    data() {
        return {
            theme: getQueryVariable("theme") ? getQueryVariable("theme") : "light",
            userChallengeId: getQueryVariable("userChallengeId"),
            challengeId: getQueryVariable("challengeId"),
            info: 0,
            activeType: 0,
            showMap: false,
            center: {lng: 116.404269, lat: 39.913385},
            map: '',
            zoom: 3,
            point: '',
            screenHeight: window.innerHeight
        }
    },
    mounted() {
        document.documentElement.setAttribute("theme", this.theme)
        if (this.userChallengeId) {
            this.getDataJoined();
        } else {
            this.getData();
        }
    },
    components: {
        BaiduMap
    },
    methods: {
        back() {
            this.$router.back();
        },
        getData() {
            this.$api.sport.getChallengeDesc({
                challengeId: this.challengeId
            }).then(res => {
                this.info = res.info
                if (this.info.getTopTen && this.info.getTopTen.length > 0) {
                    this.info.getTopTen.sort((a, b) => a.rank - b.rank)
                }
                document.title = this.getName(this.info);
                this.info.medal1 = JSON.parse(this.info.medal1);
                this.info.medal2 = JSON.parse(this.info.medal2);
                this.info.medal3 = JSON.parse(this.info.medal3);
            })
        },
        getDataJoined() {
            this.$api.sport.getChallengeDesc({
                userChallengeId: this.userChallengeId,
            }).then(res => {
                this.info = res.info
                if (this.info.getTopTen && this.info.getTopTen.length > 0) {
                    this.info.getTopTen.sort((a, b) => a.rank - b.rank)
                }
                document.title = this.getName(this.info)
                this.info.medal1 = JSON.parse(this.info.medal1);
                this.info.medal2 = JSON.parse(this.info.medal2);
                this.info.medal3 = JSON.parse(this.info.medal3);
            })
        },
        getDistanceDays(date1, date2) {
            return getDistanceDays(date1, date2)
        },
        formatSeconds(num) {
            return formatSeconds(num)
        },
        formatSeconds2(num) {
            return formatSeconds2(num)
        },
        addChallenge() {
            this.$api.sport.addChallenge({
                challengeId: this.challengeId
            }).then(res => {
                Toast.success('已加入');
                this.userChallengeId = res.info
                this.getDataJoined()
                WebJSBridge.call("addChallengeSuccess", null, function (res) {
                });
            })
        },
        // 地图初始化
        initMap({BMap, map}) {
            // map.setMapStyleV2({
            //     styleJson: mapStyle
            // })
            this.map = map;
            this.BMap = BMap;
            this.drawGPS();
        },
        drawGPS() {
            let _this = this;
            var driving = new BMap.DrivingRoute(this.map, {
                renderOptions: {map: this.map, autoViewport: true},
                onPolylinesSet: function (Route) {
                    function CircleImgOverlay(point, headerImg, {width = 31, height = 31}, type) {
                        this._point = point;
                        this._headerImg = headerImg;
                        this._width = width;
                        this._height = height;
                        this._type = type;
                    }

                    CircleImgOverlay.prototype = new BMap.Overlay();
                    CircleImgOverlay.prototype.initialize = function (map) {
                        this._map = map;
                        var divBox = document.createElement("div");
                        divBox.style.position = "absolute";
                        divBox.style.width = this._width + "px";
                        divBox.style.height = this._height + "px";
                        divBox.style.zIndex = 10032353;
                        if (this._type == 1) {
                            var divImg = document.createElement("div");
                            divImg.style.position = "absolute";
                            divImg.style.backgroundImage = `url(${this._headerImg})`;
                            divImg.style.left = "0";
                            divImg.style.top = "0";
                            divImg.style.width = "100%";
                            divImg.style.height = "100%";
                            divImg.style.borderRadius = "50%";
                            divImg.style.backgroundSize = "cover";
                            divImg.style.border = "3px solid #000000";
                            divBox.appendChild(divImg);
                        } else {
                            var divImg = document.createElement("div");
                            divImg.style.position = "absolute";
                            divImg.style.backgroundColor = getSkin('--chart-color-1');
                            divImg.style.left = "0";
                            divImg.style.top = "0";
                            divImg.style.width = "100%";
                            divImg.style.height = "100%";
                            divImg.style.borderRadius = "50%";
                            divImg.style.border = "3px solid #ffffff";
                            divBox.appendChild(divImg);

                            var divHalf = document.createElement("div");
                            divHalf.style.position = "absolute";
                            divHalf.style.background = "#FFFFFF";
                            divHalf.style.left = "-50px";
                            divHalf.style.top = "0";
                            divHalf.style.width = "48px";
                            divHalf.style.height = "24px";
                            divHalf.style.lineHeight = "24px";
                            divHalf.style.textAlign = "center";
                            divHalf.style.fontSize = "14px";
                            divHalf.style.borderRadius = "13px";
                            divHalf.style.color = getSkin('--chart-color-1');
                            divHalf.style.fontSize = "17px";
                            let textNode = document.createTextNode("半程");
                            divHalf.appendChild(textNode);
                            divBox.appendChild(divHalf);
                        }

                        // 将div添加到覆盖物容器中
                        map.getPanes().markerPane.appendChild(divBox);
                        // 保存div实例
                        this._div = divBox;
                        return divBox;
                    }
                    CircleImgOverlay.prototype.draw = function () {
                        var position = this._map.pointToOverlayPixel(this._point);
                        this._div.style.left = position.x - this._width / 2 + "px";
                        this._div.style.top = position.y - this._height / 2 + "px";
                    };
                    //当线条添加完成时调用
                    let allPArr = [];
                    for (var i = 0; i < Route.length; i++) {
                        polyline = Route[i].getPolyline();//获取线条遮挡物
                        polyline.setStrokeColor("#000000");//设置颜色
                        polyline.setStrokeWeight(5);//设置宽度
                        polyline.setStrokeOpacity(1);//设置透明度
                        allPArr = allPArr.concat(polyline.ha);
                    }
                    let pointDis = 0;
                    let headerTag = 0;
                    for (let i = 0; i < allPArr.length; i++) {
                        pointDis += _this.map.getDistance(allPArr[i], allPArr[i + 1]);

                        if ((pointDis >= _this.info.totalData / 100 && headerTag == 0) || i == allPArr.length - 1) {
                            // 画用户已完成轨迹
                            let comArr = allPArr.slice(0, i + 1);
                            var polyline = new BMap.Polyline(comArr, {
                                strokeColor: getSkin('--chart-color-1'),
                                strokeWeight: 5,
                                strokeOpacity: 1
                            });
                            _this.map.addOverlay(polyline);
                            _this.point = allPArr[i];
                            var headerImg = new CircleImgOverlay(allPArr[i], _this.info.userAvatar, {}, '1');
                            _this.map.addOverlay(headerImg);
                            break;
                        }
                    }
                    // 开始和结束图标
                    let startIcon = new BMap.Icon(require('@/assets/theme/light/sport/03challengeDesc/03start.png'), new BMap.Size(40, 40), {imageSize: new BMap.Size(40, 40)});
                    _this.map.addOverlay(new BMap.Marker(allPArr[0], {icon: startIcon}));
                    let endIcon = new BMap.Icon(require('@/assets/theme/light/sport/03challengeDesc/04end.png'), new BMap.Size(40, 40), {imageSize: new BMap.Size(40, 40)});
                    _this.map.addOverlay(new BMap.Marker(allPArr[allPArr.length - 1], {icon: endIcon}));
                },
                onMarkersSet: function (routes) {
                    _this.map.removeOverlay(routes[0].marker);
                    _this.map.removeOverlay(routes[routes.length - 1].marker);
                    for (var m = 1; m < routes.length - 1; m++) {
                        var mm = routes[m].bn;
                        _this.map.removeOverlay(mm)
                    }
                }
            });
            driving.enableAutoViewport();//自动调整层级
            let gps = this.info.gps;
            let gpsArr = gps.split(',');
            let pointArr = [];
            for (let i = 0; i < gpsArr.length - 1; i = i + 2) {
                let bPoint = new BMap.Point(gpsArr[i], gpsArr[i + 1]);
                pointArr.push(bPoint)
            }
            let wayPoints = pointArr.slice(1, pointArr.length - 1);

            driving.search(pointArr[0], pointArr[pointArr.length - 1], {waypoints: wayPoints});
        },
        setViewed() {
            this.$api.sport.setViewed({
                type: 1,
                userChallengeId: this.userChallengeId
            }).then(res => {
                this.info.showMedal = 1
            })
        },
        // 获取挑战赛名称
        getName(challenge) {
            if (challenge.attribute == 0) {
                return this.$t('challengeType.attribute0.name')
            } else {
                let monthNum = parseInt(challenge.name) - 1;
                let monthDesc = this.$t('monthArr[' + monthNum + ']');
                let name;
                if (challenge.name.indexOf('骑行') != -1) {
                    name = this.$t('challengeType.attribute' + challenge.attribute + '骑行.name');
                } else if (challenge.name.indexOf('跑步') != -1) {
                    name = this.$t('challengeType.attribute' + challenge.attribute + '跑步.name');
                } else {
                    name = this.$t('challengeType.attribute' + challenge.attribute + '.name');
                }
                if (this.$i18n.locale === 'zh') {
                    return monthDesc + name;
                } else {
                    return monthDesc + " " + name;
                }
            }
        },
        dealSportType() {
            let sportList = this.info.sportType.split(',');
            let langSport = [];
            for (let i = 0; i < sportList.length; i++) {
                let sport = this.$t("sportType." + sportList[i]);
                langSport.push(sport);
            }
            return langSport.join('/');
        }
    }
}
</script>

<style scoped>

.content {
    padding-top: 11px;
    width: 375px;
    background-color: var(--bg-color-2);
    overflow: hidden;
    position: relative;
}

.c-item {
    margin-left: 25px;
    color: var(--text-color-1);
    font-size: 15px;
    line-height: 14px;
    margin-bottom: 11px;
}

.c-text {
    display: inline-block;
    vertical-align: text-top;
}

.c-icon {
    width: 16px;
}

.c-light {
    color: var(--chart-color-1);
}

/*.content .c-item:last-child {*/
/*    padding-bottom: 15px;*/
/*}*/

/deep/ .van-tab {
    font-size: 15px;
}

/deep/ .van-tab:first-child:after {
    content: '';
    position: absolute;
    left: auto;
    top: auto;
    bottom: 14px;
    right: 0;
    height: 40%;
    width: 1px;
    opacity: 0.3;
    background-color: var(--line-color-1);
}

/deep/ .van-tabs__nav {
    background-color: transparent;
}

.info-box {
    width: 345px;
    background: var(--bg-color-2);
    border-radius: 13px 13px 13px 13px;
    margin: 15px auto 10px;
}

.info-item {
    font-size: 15px;
    width: 100%;
}

.info-key {
    color: var(--text-color-2);
    display: inline-block;
    padding: 15px 0 15px 24px;
    width: 60px;
}

.info-value {
    color: var(--text-color-1);
    margin-right: 22px;
    width: calc(100% - 130px);
    display: inline-block;
    text-align: right;
    padding-left: 15px;
}

.desc-box {
    width: 345px;
    background: var(--bg-color-2);
    border-radius: 13px 13px 13px 13px;
    margin: 0 auto;
}

.desc-title {
    color: var(--text-color-1);
    font-size: 15px;
    padding: 17px 0 0 0;
    margin: 0 23px;
}

.desc-info {
    font-size: 13px;
    color: var(--text-color-2);
    margin: 12px 23px;
    line-height: 23px;
}

.desc-last {
    padding-bottom: 8px;
}

.medal-box {
    width: 345px;
    height: 91px;
    background: var(--bg-color-2);
    border-radius: 13px 13px 13px 13px;
    margin: 0 auto;
    position: relative;
}

.d-left {
    font-size: 15px;
    color: var(--text-color-1);
    line-height: 91px;
    display: inline-block;
    padding: 0 23px;
}

.top3-left {
    color: var(--text-color-2);
}

.rank-span {
    font-size: 19px;
    color: var(--text-color-1);
}

.d-right {
    display: inline-block;
    float: right;
    padding: 15px;
}

.top3-right {
    margin-right: 23px;
}

.medal-list {
    display: flex;
    align-items: center;
    height: 61px;
}

.medal {
    width: 43px;
    margin-left: 10px;
}

.join-box {
    width: 345px;
    height: 56px;
    border-radius: 13px 13px 13px 13px;
    border: 2px solid var(--line-color-4);
    text-align: center;
    color: var(--text-color-1);
    line-height: 56px;
    font-size: 17px;
    position: absolute;
    bottom: 21px;
    left: 15px;
}

.join-box-1 {
    width: 345px;
    height: 56px;
    border-radius: 13px 13px 13px 13px;
    border: 2px solid var(--line-color-4);
    text-align: center;
    color: var(--text-color-1);
    line-height: 56px;
    font-size: 17px;
    margin: 15px auto;
}

.rank-box {
    width: 345px;
    background: var(--bg-color-2);
    border-radius: 13px 13px 13px 13px;
    margin: 15px auto;
}

.rank-title {
    font-size: 15px;
    color: var(--text-color-2);
    padding-top: 21px;
    text-align: left;
    width: 321px;
    margin: 0 auto;
    padding-bottom: 16px;
    border-bottom: 1px solid var(--line-color-3);
}

.rank-list {
    width: 321px;
    margin: 0 auto;
    font-size: 15px;
    color: var(--text-color-1);
}

.rank1 {
    color: var(--chart-color-3);
}

.rank2 {
    color: var(--chart-color-3);
}

.rank3 {
    color: var(--chart-color-15);
}

.user-icon {
    width: 20px;
    border-radius: 50%;
    vertical-align: text-bottom;
    margin-right: 2px;
}

.user-name {
    width: 120px;
    display: inline-block;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;

}

.rank-list /deep/ .van-col {
    line-height: 45px;
    height: 45px;
}

/deep/ .van-row:first-child {
    margin-top: 4px;
}

/deep/ .van-row:last-child {
    padding-bottom: 4px;
}

.see-map {
    float: right;
    font-size: 15px;
    color: var(--text-color-2);
    margin-right: 33px;
}

.down-icon {
    width: 13px;
    margin-left: 5px;
}

.map-box {
    width: 100%;
    height: calc(100vh - 60px);
    position: relative;
}

.hide-map {
    font-size: 15px;
    color: var(--text-color-1);
    position: absolute;
    right: 35px;
    bottom: 18px;
    z-index: 11;
}

.map-content {
    top: 0;
    position: absolute;
    padding-top: 11px;
    width: 60%;
    background-color: var(--bg-color-2);
    z-index: 11;
}

#map {
    width: 100%;
    height: 100%;
}

.new-item-badge {
    position: absolute;
    background: var(--text-color-1);
    color: var(--bg-color-2);
    font-weight: 500;
    z-index: 1;
    width: 100px;
    text-align: center;
    height: 50px;
    line-height: 65px;
    border-radius: 3px;
    font-size: 14px !important;
    padding: 5px 4px 0;
    font-size: 15px;
    top: -11px;
    right: -37px;
    -ms-transform: rotate(45deg);
    -webkit-transform: rotate(45deg);
    transform: rotate(45deg);
    -webkit-transition: 0 0.1s ease-in;
    -moz-transition: 0 0.1s ease-in;
    -o-transition: 0 0.1s ease-in;
    transition: transform 0.1s ease-in;
}

.no-medal {
    color: var(--text-color-1);
    font-size: 15px;
    text-align: center;
    padding-bottom: 15px;
}

.loading {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 3;
    background: rgba(0, 0, 0, 0.7);
}

.prop-box {
    width: 311px;
    height: 269px;
    background: var(--bg-color-2);
    border-radius: 13px 13px 13px 13px;
    margin: 189px auto;
    position: relative;
    text-align: center;
}

.medal-close {
    width: 25px;
    position: absolute;
    top: -105px;
    right: 25px;
}

.medal-prop {
    width: 121px;
    margin-top: -50px;
}

.medal-text1 {
    font-size: 17px;
    color: var(--text-color-1);
    margin-top: 22px;
    margin-bottom: 15px;
}

.medal-text2 {
    font-size: 30px;
    color: var(--text-color-1);
}

.accept {
    width: 116px;
    height: 34px;
    background: var(--text-color-1);
    color: var(--bg-color-2);
    border-radius: 25px 25px 25px 25px;
    font-size: 17px;
    line-height: 34px;
    margin: 22px auto;
}

.banner {
    background-color: var(--bg-color-2);
    height: 50px;
}
</style>



// WEBPACK FOOTER //
// src/views/sport/03challengeDesc.vue